import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (!user || !user.is_admin) {
    return <Navigate to="/connexion" replace />;
  }

  return children;
};

export default AdminRoute;
